module.exports = __webpack_public_path__ + "img/stuffed-peppers.3f784165.jpg";